export default "__VITE_ASSET__0W5jDBCS__";